import React from 'react';
import { styled } from '@linaria/react';

import { range } from '@/utils';

interface Props {
  value: number;
  numOfDots: number;
  dotSize: number;
  dotColor?: string;
}

function DotProgressBar({
  // `value` should be a number between 0 and 1.
  value,
  numOfDots,
  dotSize,
  dotColor = 'white',
}: Props) {
  const numOfDotsToShow = Math.round(numOfDots * value);
  const gap = dotSize / 2;

  return (
    <Wrapper style={{ gap }}>
      {range(numOfDots).map((index) => (
        <Dot
          key={index}
          data-is-filled={index < numOfDotsToShow}
          style={{
            width: dotSize,
            height: dotSize,
            backgroundColor: dotColor,
          }}
        />
      ))}
    </Wrapper>
  );
}

const Wrapper = styled.span`
  display: flex;
`;

const Dot = styled.span`
  border-radius: 50%;
  opacity: 0;

  &[data-is-filled='true'] {
    opacity: 1;
    animation: enterAnimation 600ms both;
  }

  @keyframes enterAnimation {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 1;
    }
    100% {
      opacity: 0.5;
    }
  }
`;

export default DotProgressBar;
